import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { HttpService } from 'src/app/http.service';

@Component({
  selector: 'app-hot-game-management-form',
  templateUrl: './hot-game-management-form.component.html',
  styleUrls: ['./hot-game-management-form.component.scss']
})
export class HotGameManagementFormComponent {

  @Input() company_uuid;
  @Output() closeEvent = new EventEmitter<void>();
  public games:any = []
  public _games:any = []
  public loading:boolean = false;
  private filter = {
    supplier: null,
    name: null,
    type: null
  };
  constructor(private http: HttpService) { 
    this.getAvailableGames();
  }

  async getAvailableGames() {
    this.loading = true;
    let games = await this.http.post('/admin//app/hot-game/available/get');
    this._games = games;
    this.games = games;
    this.loading = false;
  }

  searchSupplier(event: any) {
    this.filter.supplier = event.target.value;
    this.filterGames();
  }

  searchName(event: any) {
    this.filter.name = event.target.value
    this.filterGames();
  }
  
  searchType(event: any) {
    this.filter.type = event.target.value
    this.filterGames();
  }
  
  filterGames() {

    if(!this.filter.name && !this.filter.type && !this.filter.supplier) {
      this.games = this._games;
      return;
    }

    this.games = this._games.filter((v:any) => {
      let name = this.filter.name && v.name ? v.name.toLowerCase().includes(this.filter.name.toLowerCase()) : true;
      let type = this.filter.type && v.category ? v.category.toLowerCase().includes(this.filter.type.toLowerCase()) : true;
      let supplier = this.filter.supplier && v.platform ? v.platform.toLowerCase().includes(this.filter.supplier.toLowerCase()) : true;
      return name && type && supplier && v.name && v.category && v.platform;
    })
  }

  gameChecked(game:any) {
    let game_id = game.id;
    let game_index = this._games.findIndex((v:any) => v.id == game_id);

    this._games[game_index].checked = !this._games[game_index].checked;

    if(this._games[game_index].checked) {
      this._games[game_index].animate = true;
    } else {
      this._games[game_index].animate = null;
    }
  }

  animateChecked(game:any) {
    let game_id = game.id;
    let game_index = this._games.findIndex((v:any) => v.id == game_id);

    this._games[game_index].animate = !this._games[game_index].animate;
  }

  async save() {
    let games = this._games.filter((v:any) => v.checked); 

    let rtn:any = await this.http.post('/admin/app/hot-game/save', {games});
    
    if(rtn.status) {
      this.closeEvent.emit();
    }

  }

}
